import { DateFilters } from '@shape/lighthouse-components';
import { EVIDENCE_DEFAULT_PERIOD } from 'components/Evidences/hooks/useOilAnalysis';

type AnalysisType = 'OIL_ANALYSIS' | 'VIBRATION_ANALYSIS';

interface AnalysisDateFiltersProps {
  activeTab: AnalysisType;
  oilAnalysisData: {
    period?: string;
    handlePeriodChange: (value: string) => void;
  };
  vibrationAnalysisData: {
    period?: string;
    handlePeriodChange: (value: string) => void;
  };
  dateOptions: Array<{ value: string; label: string }>;
}

export const AnalysisDateFilters = ({
  activeTab,
  oilAnalysisData,
  vibrationAnalysisData,
  dateOptions,
}: AnalysisDateFiltersProps) => {
  const isOilAnalysis = activeTab === 'OIL_ANALYSIS';
  const isVibrationAnalysis = activeTab === 'VIBRATION_ANALYSIS';

  const currentAnalysisData = isOilAnalysis ? oilAnalysisData : vibrationAnalysisData;
  const defaultPeriod = currentAnalysisData.period ?? EVIDENCE_DEFAULT_PERIOD;

  const handlePeriodChange = (value: string) => {
    if (isOilAnalysis) {
      oilAnalysisData?.handlePeriodChange(value);
    } else if (isVibrationAnalysis) {
      vibrationAnalysisData?.handlePeriodChange(value);
    }
  };

  return (
    <DateFilters
      key={activeTab}
      periodOptions={dateOptions}
      enableCalendar={false}
      defaultPeriod={defaultPeriod}
      handlePeriodChange={handlePeriodChange}
      className="attach-oil-analysis-filters"
    />
  );
};
